<template>
  <el-dialog
    visible
    title="User Preferences"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-tabs tab-position="left">
      <el-tab-pane label="Search">
        <Search
          :search="configuration.search"
          :filters="configuration.filters"
        />
      </el-tab-pane>
      <el-tab-pane label="Layout">
        <Layout :layout="configuration.layout" />
      </el-tab-pane>
      <el-tab-pane label="API Keys">
        <APIKeys />
      </el-tab-pane>
      <el-tab-pane label="Reset">
        <div class="ml-3">
          <h2>Reset Configurations</h2>
          <el-button
            size="small"
            @click.native="reset"
          >
            Reset All Configurations
          </el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isLoading"
        @click.native="save"
      >
        Save
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import Search from '@/components/Navigation/Topbar/Preferences/Search'
import Layout from '@/components/Navigation/Topbar/Preferences/Layout'
import APIKeys from '@/components/Navigation/Topbar/Preferences/APIKeys'
import DefaultConfiguration from '@/store/default-configuration'
import { SET_CONFIGURATION } from '@/store/mutation-types'

export default {
  components: {
    Search,
    Layout,
    APIKeys
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      configuration: null
    }
  },
  created () {
    this.configuration = this.$_.cloneDeep(this.$store.getters.configuration)
  },
  methods: {
    async save () {
      this.isLoading = true
      try {
        this.$store.commit(`configuration/${SET_CONFIGURATION}`, this.configuration)
        await this.$user.instance.saveConfiguration()
        this.$message.success('Configurations saved')
        window.location.reload()
      } finally {
        this.isLoading = false
        this.$emit('update:isShow', false)
      }
    },
    async reset () {
      this.$confirm('Are you sure to reset all configurations to default?', 'Reset', {
        confirmButtonText: 'Reset',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        this.isLoading = true
        try {
          this.$store.commit(`configuration/${SET_CONFIGURATION}`, DefaultConfiguration)
          await this.$user.instance.saveConfiguration()
          this.$message.success('Configurations has been reset')
          window.location.reload()
        } finally {
          this.isLoading = false
          this.$emit('update:isShow', false)
        }
      }).catch(() => {})
        .finally(() => { this.$emit('update:isShow', false) })
    }
  }
}
</script>
